import { render, staticRenderFns } from "./gestion_usuarios.vue?vue&type=template&id=b967c856"
import script from "./gestion_usuarios.js?vue&type=script&lang=js&external"
export * from "./gestion_usuarios.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports